import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="800" height="800" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" className={(styles["jam"] || "jam") + " " + (styles["jam-brightness"] || "jam-brightness")} {...props}><path d="M10 18c.11 0 .11-5.33 0-16a8 8 0 100 16zm0 2a10 10 0 110-20 10 10 0 010 20z" /></svg>);